import React, { useState } from "react";
import { makeStyles } from "@material-ui/core";

import Corevalues from "../../../assets/Images/Corevalues.mp4";
import vision from "../../../assets/Images/vision.mp4";
import mission from "../../../assets/Images/mission.mp4";

const useStyles = makeStyles({
  root: {
    padding: "100px 0",
    width: "90%",
    maxWidth: "1216px",
    margin: "0 auto",
    fontFamily: "Manrope",
  },
  heading: {
    fontSize: "36px",
    fontWeight: 700,
    color: "#2C2C2C",
    textAlign: "center",
    marginBottom: "60px",
    position: "relative",
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      top: "50%",
      width: "50px",
      height: "2px",
      backgroundColor: "#FC8019",
    },
    "&::before": {
      left: 0,
    },
    "&::after": {
      right: 0,
    },
  },
  contentWrapper: {
    display: "flex",
    justifyContent: "space-between",
    gap: "40px",
    alignItems: "flex-start",
    flexWrap: "wrap",
  },
  leftNav: {
    width: "200px",
    display: "flex",
    flexDirection: "column",
    gap: "30px",
    marginTop:"60px",
    marginLeft:"30px"
  },
  navItem: {
    fontSize: "18px",
    color: "#B3B3B3",
    cursor: "pointer",
    transition: "color 0.3s ease",
    borderLeft: "4px solid transparent",
    paddingLeft: "10px",
  },
  activeNavItem: {
    color: "#8b003c",
    fontWeight: "600",
    borderLeft: "4px solid #8b003c",
  },
  videoWrapper: {
    marginTop:"-50px",
    flex: 1,
    maxWidth: "700px",
    borderRadius: "24px",
    overflow: "hidden",
  },
  video: {
    width: "100%",
    height: "auto",
    borderRadius: "24px",
    display: "block",
  },
});

const AboutAlpaaGO = () => {
  const classes = useStyles();
  const [active, setActive] = useState("vision");

  const sections = {
    mission: {
      label: "Mission",
      video: mission,
    },
    vision: {
      label: "Vision",
      video: vision,
    },
    values: {
      label: "Values",
      video: Corevalues,
    },
  };

  return (
    <div className={classes.root}>
      <div className={classes.contentWrapper}>
        <div className={classes.leftNav}>
          {Object.entries(sections).map(([key, { label }]) => (
            <div
              key={key}
              onClick={() => setActive(key)}
              className={`${classes.navItem} ${
                active === key ? classes.activeNavItem : ""
              }`}
            >
              {label}
            </div>
          ))}
        </div>
        <div className={classes.videoWrapper}>
          <video
            className={classes.video}
            autoPlay
            loop
            muted
            playsInline
            key={sections[active].video}
          >
            <source src={sections[active].video} type="video/mp4" />
          </video>
        </div>
      </div>
    </div>
  );
};

export default AboutAlpaaGO;
